import useOpus from "contexts/opus/hooks/use-opus"
import React, { useMemo, useRef } from "react"
import createPlatformClient from "./client"
import PlatformContext from "./context"

interface IPlatformProviderProps {
  children?: React.ReactNode
}

const PlatformProvider = (props: IPlatformProviderProps): JSX.Element => {
  /**
   * This is unfortunately necessary until we merge
   * session start into the platform API
   */
  const { opusToken } = useOpus()

  // Keep the last token while a new one is being fetched, but use a new token in the same render it arrives.
  // Updating it a render later (eg via an effect) let queries refetch with the previous token after switching branch
  const lastToken = useRef<string | undefined>(opusToken)
  if (opusToken) {
    lastToken.current = opusToken
  }
  const token = lastToken.current

  const platformClient = useMemo(
    () => ({
      token,
      ...createPlatformClient(token)
    }),
    [token]
  )

  return (
    <PlatformContext.Provider value={platformClient}>
      {props.children}
    </PlatformContext.Provider>
  )
}

export default PlatformProvider
